import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import authService from "../../services/auth.service";
import { normalizePhoneForApi } from "../../utils/phone";

const RESEND_COOLDOWN_SECONDS = 60;

const OtpVerification = ({
  phone,
  phoneValid,
  purpose,
  otp,
  onOtpChange,
  onError,
}) => {
  const [sending, setSending] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return undefined;

    const timer = setInterval(() => {
      setCooldown((current) => Math.max(current - 1, 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [cooldown]);

  const handleSendOtp = async () => {
    if (!phoneValid) {
      onError?.("Enter a valid phone number first");
      return;
    }

    setSending(true);
    onError?.("");

    try {
      await authService.sendOtp(phone, purpose);
      setOtpSent(true);
      setCooldown(RESEND_COOLDOWN_SECONDS);
    } catch (error) {
      onError?.(error.message || "Failed to send OTP");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-end gap-3">
        <div className="flex-1 space-y-2">
          <Label htmlFor="otp">WhatsApp OTP</Label>
          <Input
            id="otp"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => onOtpChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
            maxLength={6}
            required
          />
        </div>
        <Button
          type="button"
          variant="outline"
          className="shrink-0"
          onClick={handleSendOtp}
          disabled={!phoneValid || sending || cooldown > 0}
        >
          {sending
            ? "Sending..."
            : cooldown > 0
              ? `Resend (${cooldown}s)`
              : otpSent
                ? "Resend OTP"
                : "Send OTP"}
        </Button>
      </div>
      {otpSent && (
        <p className="text-sm text-emerald-600">
          OTP sent to your WhatsApp number ending in{" "}
          {normalizePhoneForApi(phone).slice(-4)}.
        </p>
      )}
    </div>
  );
};

export default OtpVerification;
